import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DetailViewComponent } from '../../detail-view.component';
import { DetailFormDataModel } from '../../../../config/model/detail-form-data.model';

// text,email,tel,textarea,password,
@Component({
    selector: 'text-view',
    templateUrl: './text-view.component.html',
    styleUrls: ['./text-view.component.scss'],
    standalone: false
})
export class TextViewComponent implements OnInit {
  @Input() prop: any = {};
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() detailFormDataModel: DetailFormDataModel;
  @ViewChild('inputFieldRef', { static: false }) inputFieldRef: ElementRef;

  private formField: UntypedFormControl;

  constructor(@Inject(DetailViewComponent) public _detailViewComponent: DetailViewComponent) {}

  ngOnInit() {
    // create the form field
    this.formField = new UntypedFormControl(this.prop.field_name);
    // add new form field to form group
    this.graphicFormGroup.addControl(this.prop.field_name, this.formField);
  }

  public displayValue(): string {
    const dbValue = this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name];
    let displayValue:string;
    if (this.prop.opts) displayValue = this.domainValue(); // add domains if exist
    if (!displayValue) displayValue = dbValue ? dbValue : '-';
    return displayValue;
  }

  domainValue(): string {
    let domainValue: string;
    this.prop.opts.forEach(domain => {
      const fieldValue = this.detailFormDataModel.selectedFeature.attributes[this.prop.field_name];
      if (domain.value === fieldValue) domainValue = domain.label;
    });
    return domainValue;
  }
}
